import { ApiKey } from "@/services/backend/api-key/api-key";
import { useListApiKeysQuery } from "@/services/backend/api-key/service";
import { RTKQueryErrorAlert } from "@/shared/components/domain/errors/rtk-query-error-alert";
import {
  DataTable,
  DataTableContainer,
  useDataTableController,
} from "@/shared/components/data-table";
import { CustomerName } from "@/shared/components/domain/customer/customer-name";
import type { ColumnDef } from "@tanstack/react-table";
import { useParams } from "react-router";
import { DeleteApiKeyForm } from "./delete-api-key";

const tableColumns: ColumnDef<ApiKey>[] = [
  {
    id: "Kunde",
    accessorKey: "customerId",
    header: "Kunde",
    cell: ({ row }) => <CustomerName customerId={row.original.customerId} />,
  },
  {
    id: "Ablaufzeitpunkt",
    accessorKey: "exp",
    header: "Ablaufzeitpunkt",
    cell: ({ row }) => {
      const date = new Date(row.original.exp * 1000);
      return date.toLocaleString("de-DE", { timeZone: "Europe/Berlin" });
    },
  },
  {
    id: "Aktiv",
    accessorKey: "active",
    header: "Aktiv",
    cell: ({ row }) => (row.original.active ? "Ja" : "Nein"),
  },
  {
    id: "Optionen",
    accessorKey: "id",
    header: "Optionen",
    cell: ({ row }) => (
      <div className="flex flex-row space-x-2">
        <DeleteApiKeyForm id={row.original.id} />
      </div>
    ),
  },
];

export function ApiKeyTable() {
  const { customerId } = useParams();
  const {
    data: list,
    isLoading,
    isFetching,
    error,
  } = useListApiKeysQuery(
    {
      customerId: {
        active: true,
        values: [customerId as string],
      },
    },
    {
      refetchOnMountOrArgChange: true,
    },
  );

  const table = useDataTableController(tableColumns, list?.items || []);

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  return (
    <DataTableContainer>
      <DataTable
        table={table}
        columns={tableColumns}
        isLoading={isLoading || isFetching}
      />
    </DataTableContainer>
  );
}
